import Styles from './styles.module.css';
import React from 'react';
import { useState } from 'react';
import ErrorMessage from '../../../package/error/index';
import DefaultInput1 from '../../../package/1-input/index';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { pointData } from 'src/type';

type RecruitPoint = {
  documentId: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  point: pointData;
  setPoint: React.Dispatch<React.SetStateAction<pointData>>;
};

const RecruitPagePoint: React.FC<RecruitPoint> = ({ documentId, setChangeData, point, setPoint }) => {
  
  const db = getFirestore();

  const [ errorMessage, setErrorMessage ] = useState('');

  function validateCompanyData(data: pointData): string | null {
    for (let i = 1; i <= 3; i++) {
      const key = `title${i}` as keyof pointData;
      if (!data[key]) {
        return `No.${i} 魅力のタイトルを入力してください。`;
      }
    }
    return null;
  }

  function validateAndSave() {
    setErrorMessage('');
    window.scrollTo(0, 0);

    const error = validateCompanyData(point);
    if (error) {
      setErrorMessage(error);
      return;
    }

    save(true);
  }

  const [ uploading, setUploading ] = useState(false);

  async function save(isCompleted: boolean) {
    setUploading(true);

    const dataToSend = {
      ...point,
      isCompleted,
      time: new Date(),
    };

    try {
      await updateDoc(doc(db, "recruits", documentId), {
        point: dataToSend,
      });
      setChangeData(false);
    } catch (error) {
      console.error("🔥 保存に失敗:", error);
    } finally {
      setUploading(false);
    }
  }
  
  return (
    <>
    {errorMessage && <ErrorMessage message={errorMessage} />}

    <div className={Styles.title_edit}>
      <h4>会社の魅力</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => validateAndSave()}>保存</button>
      </div>
    </div>

    <div className={Styles.test_box}>

      {[1, 2, 3].map((num) => {
        const key = `title${num}` as keyof pointData;

        return (
          <DefaultInput1
            key={num}
            error={false}
            title={`No.${num} 魅力 ※`}
            length={40}
            place=""
            value={point[key] as string}
            setValue={(val: string) => {
              setPoint(prev => ({ ...prev, [key]: val }));
              setChangeData(true);
            }}
            desc=""
            hint={{ title: "", desc: "" }}
          />
        );
      })}
        
    </div>

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}
    </>
  );
}

export default RecruitPagePoint;
